import { createTypedHooks } from 'easy-peasy'
import StoreModel from 'stores/models/interface'

const typedHooks = createTypedHooks<StoreModel>()

export const { useStoreActions } = typedHooks
export const { useStoreState } = typedHooks
